import Vue from 'vue'
import Vuex from 'vuex'

//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
const store = new Vuex.Store({
  state:{
    //存放的键值对就是所要管理的状态
    options :{}, //空间列表  空间列表删除或者新增改变更新此列表
    spaceId:null,

    stuOptions:[],
    stuSpaceId:null,

    squareOptions:[],
    squareid:null,

    squareActiveId:1, //广场选中的tab值
    squareActivepage:1,
    ulist:null, //课堂所有用户列表
    headimgurl:null,
    aigc_status:null,
  },
  mutations:{
    //更新选中 我创建的空间
    updateSpaceId(state,ids){
      if (!ids){
        localStorage.removeItem("spaceId");  //添加到localStorage
        state.spaceId = null;
      }else{
        localStorage.setItem("spaceId", ids);  //添加到localStorage
        state.spaceId = ids;
      }
    },
    //更新选中 我加入的空间
    updateStuSpaceId(state,ids){
      if (!ids){
        localStorage.removeItem("stuSpaceId");  //添加到localStorage
        state.stuSpaceId = null;
      }else{
        localStorage.setItem("stuSpaceId", ids);  //添加到localStorage
        state.stuSpaceId = ids;
      }
    },
    //更新选中 我选中的广场
    updateSquareId(state,ids){
      if (!ids){
        localStorage.removeItem("squareid");
        state.squareid = null;
      }else{
        localStorage.setItem("squareid", ids);
        state.squareid = ids;
      }
    },
    setHeadimgurl(state,headimgurl){
      state.headimgurl = headimgurl;
    },
    setAigc_status(state,aigc_status){
      if (!aigc_status){
        localStorage.removeItem("aigc_status");  //添加到localStorage
        state.aigc_status = null;
      }else{
        localStorage.setItem("aigc_status", aigc_status);  //添加到localStorage
        state.aigc_status = aigc_status;
      }
    },
  },
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js